import { coreApi } from '@/integrations/api/active';
import type { WriteResult } from '@/shared/lib/store-write';

export function ensurePlanningChecklists(
  workspaceId: string,
  cycleType: 'annual' | 'quarterly',
  year: number,
  quarter: number | null,
  items: unknown[],
): Promise<WriteResult> {
  return coreApi(`/workspaces/${workspaceId}/planning-checklists/ensure`, {
    cycle_type: cycleType, year, quarter, items,
  });
}
